<template>
  <form>
    <md-card data-tour="advanced_mcu_config">
      <md-card-header
        class="md-card-header-icon"
        :class="getClass(headerColor)"
      >
        <div class="card-icon">
          <md-icon>grid_on</md-icon>
        </div>
        <h4 class="title">MCU Configuration</h4>
        <help-link :link="helpLink.link" title="mcu"></help-link>
      </md-card-header>
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-size-33 md-small-size-100">
            <md-field>
              <label>Audio Input Max Bitrate (kbps)</label>
              <md-input
                v-model="channel.mcu.audioInput.maxBitrate"
                v-on:blur="validateMCU($v.channel.mcu.audioInput.maxBitrate)"
                type="number"
                class="full-width"
                data-tour="channel_mcu_audio_bitrate"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-33 md-small-size-100">
            <md-field>
              <label>Video Input Max Bitrate (kbps)</label>
              <md-input
                v-model="channel.mcu.videoInput.maxBitrate"
                v-on:blur="validateMCU($v.channel.mcu.videoInput.maxBitrate)"
                type="number"
                class="full-width"
                data-tour="channel_mcu_video_bitrate"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-33 md-small-size-100">
            <md-field>
              <label>Video Input Margin (px)</label>
              <md-input
                v-model="channel.mcu.videoOutput.layoutMargin"
                v-on:blur="validateMCU($v.channel.mcu.videoOutput.layoutMargin)"
                type="number"
                class="full-width"
                data-tour="channel_layout_margin"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-33 md-small-size-100">
            <md-field>
              <label>Video Output Width (px)</label>
              <md-input
                v-model="channel.mcu.videoOutput.width"
                v-on:blur="validateMCU($v.channel.mcu.videoOutput.width)"
                type="number"
                class="full-width"
                data-tour="channel_frame_width"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-33 md-small-size-100">
            <md-field>
              <label>Video Output Height (px)</label>
              <md-input
                v-model="channel.mcu.videoOutput.height"
                v-on:blur="validateMCU($v.channel.mcu.videoOutput.height)"
                type="number"
                class="full-width"
                data-tour="channel_frame_height"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-33 md-small-size-100">
            <md-field>
              <label>Video Output Frame Rate (fps)</label>
              <md-input
                v-model="channel.mcu.videoOutput.frameRate"
                v-on:blur="validateMCU($v.channel.mcu.videoOutput.frameRate)"
                type="number"
                class="full-width"
                data-tour="channel_frame_rate"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-100 md-small-size-100">
            <md-switch v-model="cropState" data-tour="channel_layout_crop">
              Crop Input Videos
            </md-switch>
            <p class="crop-switch-info">
              Fills all available space in the output video.
            </p>
          </div>
        </div>
        <div class="md-layout-item md-size-50 div-ve">
          <h5 class="h5-ve">Video Encodings</h5>
        </div>
        <md-button
          class="md-simple md-layout-item md-size-30"
          @click="
            handleNewEncoding();
            validateMCU($v.channel.videoEncodings);
          "
        >
          <md-icon>add_circle</md-icon>New
        </md-button>
        <md-table class="md-layout-item md-size-100" v-model="encodings">
          <md-table-empty-state md-description="No Video Encodings Found">
          </md-table-empty-state>
          <md-table-row slot="md-table-row" slot-scope="{ item }">
            <md-table-cell md-sort-by="getIndex(item)">
              <md-field>
                <label>Bitrate</label>
                <md-input
                  v-model="item.bitrate"
                  type="number"
                  class="full-width"
                  v-on:blur="
                    validateMCU(
                      $v.channel.videoEncodings.$each[getIndex(item)].bitrate
                    )
                  "
                ></md-input>
              </md-field>
            </md-table-cell>
            <md-table-cell>
              <md-field>
                <label>FrameRate</label>
                <md-input
                  v-model="item.frameRate"
                  type="number"
                  class="full-width"
                  v-on:blur="
                    validateMCU(
                      $v.channel.videoEncodings.$each[getIndex(item)].frameRate
                    )
                  "
                ></md-input>
              </md-field>
            </md-table-cell>
            <md-table-cell>
              <md-field>
                <label>Scale</label>
                <md-input
                  v-model="item.scale"
                  type="number"
                  step="any"
                  class="full-width"
                  v-on:blur="
                    validateMCU(
                      $v.channel.videoEncodings.$each[getIndex(item)].scale
                    )
                  "
                ></md-input>
              </md-field>
            </md-table-cell>
            <md-table-cell>
              <md-button
                class="md-just-icon md-danger md-simple"
                @click.native="handleDelete(item)"
              >
                <md-icon>close</md-icon>
              </md-button>
            </md-table-cell>
          </md-table-row>
        </md-table>
      </md-card-content>
    </md-card>
  </form>
</template>
<script>
import swal from "sweetalert2";
import validationRules from "../../validationRules";
import { HelpLinkTemplate } from "@/fmComponents";
import helpLinks from "../../contextualHelpLinks.js";

export default {
  props: {
    channel: null,
    ogChannel: null,
    headerColor: {
      type: String,
      default: "",
    },
  },
  components: {
    "help-link": HelpLinkTemplate,
  },
  data: () => ({
    helpLink: helpLinks.channelConfig.MCUConfiguration,
  }),
  validations() {
    return validationRules;
  },
  computed: {
    cropState: {
      get: function () {
        return this.channel.mcu.videoOutput.layoutCrop;
      },
      set: function (state) {
        this.channel.mcu.videoOutput.layoutCrop = state;
      },
    },
    encodings: function () {
      return this.channel.videoEncodings || [];
    },
    validationError: function () {
      return this.$v.channel.sfu.$anyError;
    }
  },
  methods: {
    getClass: function (headerColor) {
      return "md-card-header-" + headerColor + "";
    },
    validateMCU: function (input) {
      if (input != undefined) {
        input.$touch();

        if (
          input == this.$v.channel.videoEncodings &&
          !this.$v.channel.videoEncodings.maxLength
        ) {
          this.$store.commit(
            "pushError",
            "Supported Video Encodings are maximum 3 elements."
          );
          this.channel.videoEncodings.pop();
        }

        if (this.$v.channel.mcu.audioInput.maxBitrate.$error) {
          this.$store.commit(
            "pushError",
            "Supported MCU Audio Input Max Bitrate is between 1kbps and 200kbps."
          );
        }
        if (this.$v.channel.mcu.videoInput.maxBitrate.$error) {
          this.$store.commit(
            "pushError",
            "Supported MCU Video Input Max Bitrate is between 1kbps and 20,000kbps."
          );
        }
        if (this.$v.channel.mcu.videoOutput.width.$error) {
          this.$store.commit(
            "pushError",
            "Supported MCU Video Output Width is between 160 and 1920."
          );
        }
        if (this.$v.channel.mcu.videoOutput.height.$error) {
          this.$store.commit(
            "pushError",
            "Supported MCU Video Output Height is between 120 and 1080."
          );
        }
        if (this.$v.channel.mcu.videoOutput.frameRate.$error) {
          this.$store.commit(
            "pushError",
            "Supported MCU Video Output Frame Rate is between 1 and 30."
          );
        }

        if (
          this.channel.videoEncodings.some((v, i) => {
            return this.$v.channel.videoEncodings.$each[i].bitrate.$error;
          })
        ) {
          this.$store.commit(
            "pushError",
            "Supported Video Encoding Bitrate is between 100 and 3000."
          );
        }
        if (
          this.channel.videoEncodings.some((v, i) => {
            return this.$v.channel.videoEncodings.$each[i].frameRate.$error;
          })
        ) {
          this.$store.commit(
            "pushError",
            "Supported Video Encoding Frame Rate is between 1 and 30."
          );
        }
        if (
          this.channel.videoEncodings.some((v, i) => {
            return this.$v.channel.videoEncodings.$each[i].scale.$error;
          })
        ) {
          this.$store.commit(
            "pushError",
            "Supported Video Encoding Scale is between 0.01 and 1.00."
          );
        }

        if (this.$v.channel.mcu.videoOutput.layoutMargin.$error) {
          this.$store.commit(
            "pushError",
            "Supported Layout Margin is positive value."
          );
        }
      }
    },
    handleNewEncoding() {
      var newEncoding = {
        bitrate: null,
        frameRate: null,
        scale: null,
      };
      this.channel.videoEncodings.push(newEncoding);
    },

    handleDelete(item) {
      this.channel.videoEncodings.splice(this.getIndex(item), 1);
    },
    getIndex(item) {
      return this.channel.videoEncodings.indexOf(item);
    },
  },
  watch: {
    validationError(val) {
      this.$emit("validationErrorChanged", this, val);
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/ h5.h5-sc {
  margin-top: 20px;
  margin-bottom: 0;
}
/deep/ div.div-ve {
  float: left;
}
/deep/ h5.h5-ve {
  margin-top: 15px;
  margin-bottom: 0;
  font-size: 1rem;
}
/deep/ th.md-table-head {
  display: none;
}
/deep/ button.md-button.md-simple {
  float: right;
}
/deep/ .md-table-cell {
  padding-bottom: 0;
  max-width: 70px;
}
/deep/ .md-table-cell:last-child {
  padding: 0;
  width: 24px;
}

/deep/ .crop-switch-info {
  margin: -10px 0 0 0;
  color: #aaaaaa;
}

@media only screen and (max-width: 450px) {
  /deep/ .md-table-cell {
    padding: 2px;
  }
}

@media screen and (min-width: 1138px) {
  h4.title {
    display: inline-flex;
  }
  .contextual-help {
    display: inline-flex;
    float: right;
    margin-top: 21px;
  }
  /deep/ .contextual-help > a {
    padding-top: 2px;
  }
}
</style>
